export default __webpack_public_path__ + "static/media/icon-coming-soon.7cb1e038.png";